var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M52 56H13.33A5.33 5.33 0 0 1 8 50.67V13.33A5.33 5.33 0 0 1 13.33 8H40a5.33 5.33 0 0 1 5.33 5.33v36A6.67 6.67 0 0 0 52 56Zm0 0h1.33a8 8 0 0 0 0-16H52m-33.33-2.43h16m-16 7.76h12m14.66-34.66A5.33 5.33 0 0 1 50.67 16v29.33m0 0v2.91a2.42 2.42 0 0 0 2.42 2.43h.24a2.67 2.67 0 0 0 0-5.34h-2.66ZM18.73 23.16V16h6.6a4.1 4.1 0 0 1 2.74 7.16m-9.34 0v7.16h8.8c4.46 0 4.94-6.5.54-7.16m-9.34 0h9.34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogB);
export default __webpack_public_path__ + "static/media/blog_b.1137ced3acc14fe5fb4fc55390839dc7.svg";
export { ForwardRef as ReactComponent };